var domFunctions = require('../utils/_domFunctions');

class mPageWithMenu extends HTMLDivElement {
    constructor() {
        super();
        this.updatePageContent = this.updatePageContent.bind(this);
        this.updateMenu = this.updateMenu.bind(this);
        this.updateContent = this.updateContent.bind(this);
        this.contentContainer = this.querySelector('[data-page-content-container]');
        this.menuContainer = this.querySelector('[data-page-menu-container]');
        this.bindUpdateButtons = this.bindUpdateButtons.bind(this);
    }

    connectedCallback() {
        this.updateContentButtons = this.querySelectorAll('[data-component-update-content]');
        this.bindUpdateButtons(this.updateContentButtons);
    }

    bindUpdateButtons(buttons) {
        buttons.forEach((button) => {
            button.addEventListener('click', this.updateContent);
        });
    }

    updateContent(e) {
        // Use preventDefault to avoid to be redirected to href URL
        // Do not empty href, used for new tab opening
        e.preventDefault();

        const elem = e.currentTarget;
        const url = elem.href; // elem.dataset.jsUrl;

        fetch(url, {
            method: 'GET'
        }).then((response) => {
            return response.text();
        }).then((responseData) => {
            // Passing from string to HTMLElement
            let newHtml = domFunctions.stringToHTML(responseData);

            // Updating header
            const head = newHtml.querySelector('head');
            document.head.outerHTML = head.outerHTML;

            // Update the page content
            const content = newHtml.querySelector('[data-page-content-container]');
            this.contentContainer.innerHTML = content.innerHTML;

            // bind new buttons with same behavior than menu buttons
            const newButtons = this.contentContainer.querySelectorAll('[data-component-update-content]');
            this.bindUpdateButtons(newButtons);

            // Update url with curent section
            window.history.pushState({}, '', elem.href);
        });
    }
}

customElements.define('m-page-with-menu', mPageWithMenu, {
    extends: 'div'
});
